import React from 'react';
import {
  GuestInvoiceDownloadPayload,
  openGuestInvoiceDownload,
} from '../../../utils/guestInvoiceDownload';
import './GuestInvoiceDownload.css';

interface GuestInvoiceDownloadProps {
  appName: string;
  orderId: number;
  invoiceDownload?: GuestInvoiceDownloadPayload | null;
  className?: string;
  compact?: boolean;
}

const GuestInvoiceDownload: React.FC<GuestInvoiceDownloadProps> = ({
  appName,
  orderId,
  invoiceDownload,
  className = '',
  compact = false,
}) => {
  if (!invoiceDownload?.available || !invoiceDownload.invoices?.length) {
    return null;
  }

  const invoices = invoiceDownload.invoices;

  if (invoices.length === 1) {
    const inv = invoices[0];
    return (
      <button
        type="button"
        className={`guest-invoice-download-btn${compact ? ' guest-invoice-download-btn--compact' : ''} ${className}`.trim()}
        onClick={() => openGuestInvoiceDownload(appName, orderId, inv.invoiceId)}
      >
        <i className="fa fa-download" aria-hidden />
        {compact ? 'Invoice' : 'Download invoice'}
        {inv.invoiceNo ? (
          <span className="guest-invoice-download-btn__no">{inv.invoiceNo}</span>
        ) : null}
      </button>
    );
  }

  return (
    <div className={`guest-invoice-download-group${compact ? ' guest-invoice-download-group--compact' : ''} ${className}`.trim()}>
      {invoices.map((inv) => (
        <button
          key={inv.invoiceId}
          type="button"
          className={`guest-invoice-download-btn${compact ? ' guest-invoice-download-btn--compact' : ''}`}
          onClick={() => openGuestInvoiceDownload(appName, orderId, inv.invoiceId)}
        >
          <i className="fa fa-download" aria-hidden />
          {inv.label || inv.invoiceNo || 'Download invoice'}
        </button>
      ))}
    </div>
  );
};

export default GuestInvoiceDownload;
